import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";
import { PostLeagueFlight, TPostLeagueFlight } from "api/rpc/2024-04/facilityAdmin/league/scoring/flight";
import { showError, showSuccess } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";

import Page from "components/page/Page";
import Card from "components/card/Card";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";

export default function LeagueFlightsNew() {
  const history = useHistory();
  const { t } = useTranslation();
  const { leagueId, divisionId } = useParams<{ leagueId: string; divisionId: string }>();

  const dispatch = useAppDispatch();

  const [flightState, setFlightState] = useState<TPostLeagueFlight>({
    league_id: leagueId,
    league_division_id: divisionId,
    name: "",
  });

  async function createFlight() {
    const leagueRes = await PostLeagueFlight(flightState, true);
    if (leagueRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating new flight")));
      return;
    }
    dispatch(showSuccess(t("Successfully created new flight")));
    history.push(`/admin/league/${leagueId}/divisions/${divisionId}/flights`);
  }

  const primaryAction = {
    content: t("secure.facility.league.new.008"),
    action: () => createFlight(),
    disabled: !flightState.name,
  };

  return (
    <Page
      title={t("New Flight")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Flights"),
          url: `/admin/league/${leagueId}/divisions/${divisionId}/flights`,
        },
      ]}
    >
      <Form>
        <Card title={t("Flight Details")}>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  value={flightState.name ?? ""}
                  label={t("secure.facility.league.new.012")}
                  id="name"
                  onChange={e => setFlightState(prev => ({ ...prev, name: e.target.value }))}
                  placeholder={t("secure.facility.league.new.012")}
                />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      </Form>
    </Page>
  );
}
